export default __webpack_public_path__ + "static/media/sp-icon-active.bff05d53.svg";